module.exports = __webpack_public_path__ + "img/09.e9a475f7.jpg";